module.exports = __webpack_public_path__ + "static/media/default_profile_image.ddc95f14.png";